import React from "react";

class Error404 extends React.Component {
    componentDidMount() {
        document.title = "Erreur - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
    }
    render() {
        return <div className="pboutique">
            <h2 className="pboutique__ttl">Désolé, cette page n'existe pas</h2>
        </div>
    }
}

export default Error404;